module.exports = __webpack_public_path__ + "static/img/sciencegroove.8ba72b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ui/sciencegroove.png
// module id = gb0o
// module chunks = 1